import React from "react";
import {
  SectionContainer,
  Title,
  Description,
  Image,
  DescriptionContent,
} from "./styles";
import image from "../../assets/api.png";

const AboutSebraeApi = () => {
  return (
    <SectionContainer>
      <DescriptionContent>
        <Title>Sobre as APIs do Sebrae</Title>
        <Description>
          Lorem Ipsum is simply dummy text of the printing and typesetting
          industry. Lorem Ipsum has been the industry's standard dummy text ever
          since the 1500s, when an unknown printer took a galley of type and
          scrambled it to make a type specimen book. It has survived not only
          five centuries, but also the leap into electronic typesetting.
        </Description>
      </DescriptionContent>
      <Image alt="imagem" src={image} />
    </SectionContainer>
  );
};

export default AboutSebraeApi;
